export interface Feature {
  key: string;
  label: string;
}

// Don't rename `t` because Lexi is using it to find all translation keys.
export const getFeatures = (t: TranslateGlobalFunction): Feature[] => [
  {
    key: 'impression_tracking',
    label: t('feature.impression_tracking'),
  },
  {
    key: 'raw_export_settings',
    label: t('feature.raw_data_exports'),
  },
  {
    key: 'google_organic_search',
    label: t('feature.google_organic_search'),
  },
  {
    key: 'cost_data',
    label: t('feature.cost_data'),
  },
  {
    key: 'api_access',
    label: t('feature.api_access'),
  },
  {
    key: 'attribution_settings',
    label: t('feature.attribution_settings'),
  },
  {
    key: 'tv_tracking',
    label: t('feature.tv_tracking'),
  },
  {
    key: 'tracker_attribution_settings',
    label: t('feature.tracker_attribution_settings'),
  },
  {
    key: 'first_source_dynamic_source',
    label: t('feature.first_source_dynamic_source'),
  },
];
